/** Cài đặt Gợi ý trả lời của doanh nghiệp (BE: POST /chatbot/ai/suggestsettings, BusinessSettings type 44). */

/** Phạm vi AI (gợi ý trả lời, tự chấm điểm): loại hội thoại, mã tag dùng AI, mã tag không dùng AI. */
export interface IAiScopeValue {
  types: number[];
  /** Có tag này mới dùng AI; trống = mọi hội thoại. */
  includeTagIds: string[];
  /** Có tag này thì không dùng AI. */
  excludeTagIds: string[];
}

/** Loại hội thoại AI được dùng, giống Page::AI_SCOPE_TYPES bên BE. */
export const AI_SCOPE_TYPE_OPTIONS = [
  { value: 1, key: 'comment' },
  { value: 2, key: 'message' },
  { value: 3, key: 'group' },
] as const;

export interface IAiSuggestSettings {
  /** Bật gợi ý trả lời cho mọi page chưa cài riêng (BE mặc định bật). */
  enabled: boolean;
  /** Tự gợi ý khi mở hội thoại, khách nhắn mới; tắt thì nhân viên bấm Tạo gợi ý. */
  auto: boolean;
  /** Số câu gợi ý mỗi lần. */
  count: number;
  /** Chưa có tin mới thì dùng lại gợi ý đã tạo (không gọi AI lại) trong cacheMinutes phút. */
  cache: boolean;
  cacheMinutes: number;
  /** Hội thoại dùng AI chung cho mọi page chưa cài riêng. */
  scope: IAiScopeValue;
  version: number;
  updatedAt: number;
  updatedBy: string;
}

/** Số câu gợi ý và thời gian dùng lại gợi ý chọn được (khớp BE SuggestSettingsService). */
export const AI_SUGGEST_COUNTS = [1, 2, 3, 4, 5] as const;
export const AI_SUGGEST_CACHE_MINUTES = [10, 60, 1440] as const;

/**
 * Một dòng tab Theo page: page, trợ lý đang gắn, cài riêng của page (custom 1 riêng, 2 theo doanh nghiệp): suggest 1 bật,
 * 2 tắt gợi ý; hội thoại dùng AI.
 */
export interface IAiSuggestPageRow {
  pageId: string;
  name: string;
  avatar: string;
  channel: number;
  assistant: { id: string; name: string } | null;
  aiScope: IAiScopeValue & { custom: number; suggest: number };
}

/** Đổi cài đặt của page: custom 1 kèm đủ giá trị, custom 2 = theo doanh nghiệp (BE nhận pages là chuỗi JSON). */
export type IAiSuggestPageUpdate = { pageId: string; custom: number; suggest?: number } & Partial<IAiScopeValue>;

export interface IAiSuggestSettingsData {
  settings: IAiSuggestSettings;
  pages: IAiSuggestPageRow[];
}
